import React from 'react';
import PropTypes from 'prop-types';
import { useReactiveVar } from '@apollo/client';
import { Grid, Dialog, DialogContent, DialogTitle } from '@mui/material';

import { accountStatementIndicatorModalVar } from './variables';
import AccountStatementIndicatorsModalEditContainer from './AccountStatementIndicatorsModalEditContainer';
import { useTranslation } from 'react-i18next';

const AccountStatementIndicatorsModalComponent = ({configId, indicators}) => {
  const editStatementIndicator = useReactiveVar(accountStatementIndicatorModalVar);
  const { t } = useTranslation();
  return (
    <Dialog
      id={`indicator_${editStatementIndicator?.item?.statementIndicatorId}`}
      open={editStatementIndicator.open}
      maxWidth='md'
      fullWidth
      TransitionProps={{ exit: false }}
    >
      <Grid container sx={{ p: 1 }}>
        <DialogTitle color='primary' fontWeight='bold' variant='subtitle1' sx={{ pr: 0.5 }}>
          {editStatementIndicator?.item?.statementIndicatorId ?
            `${t('AccountStatement.Indicators.EditIndicator')}: ${editStatementIndicator?.item?.name}` : t('AccountStatement.Indicators.AddIndicator')}
        </DialogTitle>
      </Grid>
      <DialogContent sx={{ paddingTop: 0 }}>
        {editStatementIndicator.open && <AccountStatementIndicatorsModalEditContainer indicator={editStatementIndicator.item} configId={configId} indicators={indicators}/>}
      </DialogContent>
    </Dialog>
  );
};

AccountStatementIndicatorsModalComponent.propTypes = {
  configId: PropTypes.number.isRequired,
  indicators: PropTypes.array.isRequired
};

export default AccountStatementIndicatorsModalComponent;
